import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { GET_APPLICATION_URL, GET_CONTRACT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetContract extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_CONTRACT_URL;

  constructor(applicationId, applicationType, productId) {
    super();
    const paramList = [applicationId, applicationType, productId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
